import styled from 'styled-components';
import { getTheme, size } from 'mol-ui';

export const Container = styled.div`
    align-items: center;
    border: 1px solid ${ getTheme('primaryColor') };
    border-radius: 4px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    max-height: 380px;
    min-height: 380px;
    min-width: 358px;
    max-width: 358px;
    padding: 0px 9px 20px 9px;
    
    ${ size.xs(`
        border-radius: 0px;
        min-width: 360px;
        max-width: 360px;
        padding: 20px 0px;   
    `) }
`;
